import React, { Component } from 'react';
import cookie from 'react-cookie';

class UserCondition extends Component {

	constructor() {
		super();

		this.state = {
			isLoggedIn: false			
		};

		this.conditionalContent = () => { return this.state.isLoggedIn === this.props.isLoggedIn  ? this.props.children : null};
	}

	componentWillMount() {		
		let jwt = cookie.load('webfinery.jwt', { path: '/'});
		const isLoggedIn = (jwt !== null && jwt !== undefined);	
    	this.setState({isLoggedIn: isLoggedIn });
	}

	render() {
		return (
			<span>
				{ /* this.state.isLoggedIn ? "true" : "false"} / {this.state.isLoggedIn === this.props.isLoggedIn ? "true" : "false" */}
				{this.conditionalContent()}
			</span>
		);
	}
}

export default UserCondition;



// WEBPACK FOOTER //
// ./src/UserCondition.js